export default __webpack_public_path__ + "static/media/chatbot.eec6ec32.png";